import { useState } from "react";
import { useRoles } from "src/context/roles-context";
import type { ToolConfig } from "../types/ToolConfig";

interface ToolSearchProps {
 tools: ToolConfig[];
 categoryLabel: string; // e.g. "HR Tools", "IT Tools"
 onToolSelect: (tool: string) => void;
 initialTool?: string;
}

function ToolSearch({ tools, categoryLabel, onToolSelect, initialTool = "" }: ToolSearchProps) {
 const roles = useRoles();

 const availableTools = tools.filter(
   (tool) =>
     tool.requiredRoles === null ||
     tool.requiredRoles.some((role) => roles.checkHasRole(role))
 );

 const [selectedTool, setSelectedTool] = useState(initialTool);

 const selectedToolConfig = availableTools.find((t) => t.name === selectedTool);

 function handleSubmit() {
   if (selectedTool) {
     onToolSelect(selectedTool);
   }
 }

 return (
   <div className="p-3 space-y-3 overflow-y-auto max-h-[calc(100vh-64px)]">
     <div className="bg-gray-50 rounded-md shadow-sm border border-gray-200">
       <div className="p-2">
         <fieldset className="fieldset mb-0">
           <legend className="fieldset-legend text-xs font-medium text-gray-600">
             {categoryLabel}
           </legend>

           <div className="relative">
             <select
               className="input input-bordered input-sm w-full pl-3 pr-8 hover:bg-gray-200 hover:underline"
               value={selectedTool}
               onChange={(e) => setSelectedTool(e.target.value)}
             >
               <option value="" disabled hidden>
                 ----Select a Tool----
               </option>
               {availableTools.map((tool) => (
                 <option key={tool.name} value={tool.name}>
                   {tool.name}
                 </option>
               ))}
             </select>
           </div>
         </fieldset>
       </div>
     </div>

     {selectedToolConfig && (
       <div className="bg-white rounded-md shadow-sm border border-gray-200">
         <div className="px-3 py-2 border-b border-gray-200 bg-gray-50 rounded-t-md">
           <h4 className="text-xs font-medium text-gray-700">Tool Description</h4>
         </div>
         <div className="max-h-48 overflow-y-auto">
           <div className="p-2">
             <p className="text-xs text-gray-600">{selectedToolConfig.description}</p>
           </div>
         </div>
       </div>
     )}

     <div>
       <button
         type="button"
         onClick={handleSubmit}
         disabled={!selectedTool}
         className="btn btn-primary btn-sm mt-3 hover:bg-sky-800 hover:underline"
       >
         Select Tool
       </button>
     </div>
   </div>
 );
}

export { ToolSearch };